// extracted by mini-css-extract-plugin
export default {"shareButtonsContainer":"ShareComponent_shareButtonsContainer__98qpr"};